export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      services: "Services",
      kids: "Cours Enfants",
      about: "Notre Histoire",
      coaches: "Coachs",
      pricing: "Tarifs",
      booking: "Réserver",
      book_cta: "Réserver une séance",
      account: "Mon compte",
    },
    account: {
      title: "Mon compte",
      login_tab: "Connexion",
      register_tab: "Créer un compte",
      email: "Courriel",
      password: "Mot de passe",
      password_confirm: "Confirmer le mot de passe",
      name: "Nom complet",
      phone: "Numéro de téléphone",
      address: "Adresse (rue)",
      city: "Ville",
      postal_code: "Code postal",
      province: "Province",
      login_submit: "Se connecter",
      register_submit: "Créer mon compte",
      logout: "Déconnexion",
      welcome: "Bonjour",
      profile_title: "Mes informations",
      bookings_title: "Mes réservations",
      no_bookings: "Aucune réservation pour le moment.",
      save: "Enregistrer les modifications",
      saved: "Profil mis à jour.",
      password_mismatch: "Les mots de passe ne correspondent pas.",
      booking_date: "Date",
      booking_package: "Formule",
      booking_status: "Statut",
      booking_payment: "Paiement",
      book_cta: "Réserver une séance",
      availability_title: "Mes disponibilités",
      availability_help: "Cochez les créneaux où vous êtes généralement disponible (semaine et fin de semaine). Un gestionnaire vous contactera pour valider.",
      manager_notice: "Merci ! Un gestionnaire vous contactera sous peu pour valider vos disponibilités et planifier votre première séance en fonction de l'horaire déjà réservé.",
    },
    days: {
      mon: "Lundi", tue: "Mardi", wed: "Mercredi", thu: "Jeudi",
      fri: "Vendredi", sat: "Samedi", sun: "Dimanche",
    },
    periods: { am: "Matin", pm: "Après-midi", eve: "Soir" },
    home: {
      overline: "Natation · Cyclisme · Triathlon",
      title_l1: "Entrer",
      title_l2: "dans le",
      title_accent: "Flow",
      subtitle:
        "Coaching sportif sur mesure pour nageurs et cyclistes. De la première brasse au podium, nous construisons votre performance avec méthode.",
      cta_primary: "Réserver ma séance",
      cta_secondary: "Notre histoire",
      identity_overline: "La méthode FLOW",
      identity_title: "Le sport pensé comme un art du mouvement.",
      identity_body:
        "Chaque athlète est unique. Notre approche conjugue technique, physiologie et plaisir pour révéler votre potentiel — quel que soit votre niveau.",
      services_overline: "Nos disciplines",
      services_title: "Deux univers, une même exigence.",
      service_swim_title: "Natation",
      service_swim_body:
        "Technique de nage, eau libre, préparation triathlon. Cours individuels en piscine et stages en lac.",
      service_cycle_title: "Cyclisme",
      service_cycle_body:
        "Route, gravel, home-trainer. Plans d'entraînement personnalisés, analyse de puissance et préparation course.",
      learn_more: "En savoir plus",
      stats: {
        athletes: "Athlètes coachés",
        years: "Années d'expérience",
        races: "Podiums clients",
        rating: "Satisfaction",
      },
      testimonials_overline: "Ils nous ont fait confiance",
      testimonials_title: "Des résultats qui parlent.",
    },
    kids: {
      overline: "Cours pour enfants",
      title: "La natation, dès les premières années.",
      body:
        "Bébés-nageurs, enfants, adolescents : nous proposons des cours adaptés à chaque âge — du tout premier contact avec l'eau au perfectionnement de la technique. Approche ludique, sécuritaire et progressive, encadrée par des entraîneurs certifiés par la Société de sauvetage.",
      bullet1: "Parents-enfants",
      bullet2: "Préscolaires",
      bullet3: "Niveaux 1 à 6",
      bullet4: "Jeunes sauveteurs",
      cta: "Réserver pour mon enfant",
    },
    kidspage: {
      overline: "Cours de natation pour enfants",
      title: "La natation, dès les premières années.",
      lead:
        "Bébés-nageurs, enfants, adolescents : nous proposons des cours adaptés à chaque âge — du tout premier contact avec l'eau au perfectionnement de la technique. Une approche ludique, sécuritaire et progressive, encadrée par des entraîneurs certifiés par la Société de sauvetage.",
      badge: "Programme officiel Nager pour la vie — Société de sauvetage",
      kids_groups_title: "Programmes enfants & jeunes",
      m1_title: "Parent et enfant",
      m1_levels: "Niveaux 1 · 2 · 3",
      m1_age: "Jusqu'à 3 ans",
      m1_desc: "Avec un parent dans l'eau : éveil aquatique, confiance et premiers réflexes, en toute sécurité.",
      m2_title: "Préscolaire",
      m2_levels: "Niveaux 1 à 5",
      m2_age: "3 à 5 ans",
      m2_desc: "Familiarisation avec l'eau, flottaison, immersion et premiers déplacements, le tout par le jeu.",
      m3_title: "Nageur",
      m3_levels: "Niveaux 1 à 6",
      m3_age: "5 ans et +",
      m3_desc: "Apprentissage des styles de nage, endurance et technique pour gagner en aisance et en autonomie.",
      m4_title: "Nageur — Jeune sauveteur",
      m4_levels: "Niveaux 7 · 8 · 9",
      m4_age: "8 ans et +",
      m4_desc: "Perfectionnement, endurance et premières habiletés de sauvetage. Prépare à la suite du parcours.",
      bronze_label: "Et après ?",
      bronze_title: "Étoile de Bronze · Nageur 10",
      bronze_desc: "Pour poursuivre ta formation vers le programme de sauveteur, inscris-toi à l'Étoile de Bronze (Nageur 10).",
      adults_title: "Adultes & forme physique",
      a1_title: "Nageur adulte",
      a1_levels: "Niveaux 1 · 2 · 3",
      a1_age: "16 ans et +",
      a1_desc: "Apprendre à nager ou se perfectionner à tout âge, à son rythme.",
      a2_title: "Forme physique",
      a2_levels: "Tous niveaux",
      a2_age: "Tout âge",
      a2_desc: "Pour les nageurs de tout âge qui souhaitent améliorer leur forme physique générale.",
      survive_label: "Sécurité aquatique",
      survive_title: "La Norme Nager pour survivre",
      survive_lead: "La norme Nager pour survivre permet d'évaluer les habiletés aquatiques de chaque enfant et de leur enseigner les habiletés de base nécessaires pour survivre à une chute inattendue en eau profonde.",
      s1_skill: "Entrée par roulade",
      s1_goal: "S'orienter à la surface de l'eau après une chute inattendue.",
      s2_skill: "Nage sur place pendant 1 minute",
      s2_goal: "Se maintenir à la surface et repérer un lieu sûr.",
      s3_skill: "Nage sur 50 mètres",
      s3_goal: "Nager vers un endroit sécuritaire.",
      why_title: "Pourquoi nous confier vos enfants",
      why1_title: "La sécurité avant tout",
      why1_desc: "Entraîneurs certifiés par la Société de sauvetage. La sécurité guide chaque séance.",
      why2_title: "Une approche ludique",
      why2_desc: "Apprendre en s'amusant : des jeux et des défis adaptés pour que chaque enfant progresse avec plaisir.",
      why3_title: "À domicile ou en piscine",
      why3_desc: "Cours privés sur mesure dans le grand Montréal, selon votre horaire et le rythme de votre enfant.",
      book_module: "Réserver ce programme",
      cta: "Réserver pour mon enfant",
      cta_secondary: "Poser une question",
    },
    services: {
      overline: "Services",
      title: "Coaching natation & cyclisme sur mesure.",
      subtitle:
        "Pour tous les âges et niveaux — de bébé au triathlète. Entraîneurs certifiés Cyclisme Canada et Société de sauvetage.",
      swim_title: "Natation",
      swim_body:
        "Des premiers contacts avec l'eau jusqu'à la préparation triathlon ou eau libre. Cours adaptés à chaque profil — bébés, enfants, ados, adultes, compétiteurs.",
      swim_bullet1: "Cours privés (tous les âges et niveaux)",
      swim_bullet2: "Perfectionnement de styles",
      swim_bullet3: "Plans d'entraînement (triathlon, eau libre, piscine)",
      swim_bullet4: "Coaching pour débutants à avancés",
      swim_bullet5: "Préparation tests / examens (sauvetage, premiers répondants, etc.)",
      cycle_title: "Cyclisme",
      cycle_body:
        "Coaching individualisé route, piste et triathlon. Plans structurés, analyse technique fine et préparation aux compétitions ou défis personnels.",
      cycle_bullet1: "Coaching personnalisé (route, piste, triathlon)",
      cycle_bullet2: "Plans d'entraînement structurés",
      cycle_bullet3: "Analyse technique (position, cadence, efficacité)",
      cycle_bullet4: "Préparation compétition (70.3, Gran Fondo, etc.)",
      cycle_bullet5: "Suivi hebdomadaire personnalisé",
      cycle_bullet6: "Positionnement vélo",
    },
    about: {
      overline: "Notre histoire",
      title: "Né de la passion. Construit pour la performance.",
      p1:
        "FLOW est né en 2025 à Montréal, fondé par une sauveteuse diplômée en travail social et étudiante en kinésiologie. Révoltée par le prix des cours privés — au point que faire du sport soit devenu un luxe —, elle a décidé de changer les choses.",
      p2:
        "Sa conviction : le coaching privé devrait être accessible à tous, sans jamais sacrifier la qualité ni l'expertise. Ici, on reste humains, à l'écoute de chaque client qui cherche à s'améliorer et à devenir une meilleure version de lui-même.",
      p3:
        "Certifiés par la Société de sauvetage et Cyclisme Canada, nous accompagnons nageurs et cyclistes de tous niveaux à travers une approche personnalisée : comprendre votre histoire, vos contraintes, vos objectifs — puis bâtir un programme qui les respecte tous.",
      p4:
        "Au fil des dernières années, l'équipe s'est agrandie : des entraîneurs tous certifiés et expérimentés rejoignent FLOW pour faire grandir la communauté.",
      p5:
        "Aujourd'hui, plus de 100 athlètes nous ont fait confiance — du débutant absolu au triathlète chevronné. Chaque histoire est unique, et nous l'écrivons avec vous.",
      values_title: "Notre mission",
      v1_title: "Accessible à tous",
      v1_body: "Rendre le coaching privé abordable et accessible pour tous.",
      v2_title: "Progresser sainement",
      v2_body: "Aider à progresser et à développer une relation saine avec la performance.",
      v3_title: "Une communauté",
      v3_body: "Créer une communauté qui s'entraîne avec plaisir, discipline et équilibre.",
    },
    coaches: {
      overline: "L'équipe",
      title: "Votre coach.",
      subtitle:
        "Une approche personnelle, une seule exigence : la vôtre.",
    },
    pricing: {
      overline: "Tarifs",
      title: "Choisissez votre formule.",
      subtitle:
        "Coaching en natation sur mesure et suivi cyclisme virtuel. Des frais de déplacement s'appliquent uniquement à l'extérieur de Montréal.",
      per_session: "par séance",
      total: "Total",
      book_now: "Réserver",
      popular: "Le plus choisi",
      swim_section: "Natation enfants & jeunes",
      swim_section_sub: "Jusqu'à 15 ans · cours de 30 minutes",
      swim_adult_section: "Natation adulte",
      swim_adult_section_sub: "16 ans et plus · cours d'une heure",
      cycle_section: "Cyclisme",
      cycle_section_sub: "Vélo de route uniquement",
      tri_section: "Triathlon",
      travel_notice: "Frais de déplacement de 15$ à 30$ uniquement pour les séances à l'extérieur de Montréal (selon la distance).",
    },
    booking: {
      overline: "Réservation",
      title: "Réservez votre séance.",
      subtitle:
        "Remplissez le formulaire — nous vous confirmons votre créneau sous 24h.",
      summary_title: "Récapitulatif",
      program: "Programme sélectionné",
      step_package: "Formule",
      step_about: "À propos de vous",
      step_profile: "Votre profil sportif",
      step_contact: "Coordonnées",
      step_date: "Date & créneau",
      full_name: "Nom et prénom",
      gender: "Genre",
      gender_female: "Femme",
      gender_male: "Homme",
      gender_other: "Autre / Préfère ne pas répondre",
      age: "Âge",
      region: "De quelle région habitez-vous ?",
      region_montreal: "Montréal",
      region_rive_sud: "Rive-Sud",
      region_rive_nord: "Rive-Nord",
      region_other: "Autre",
      sport: "Lequel de nos sports vous intéresse ?",
      sport_swim: "Natation",
      sport_cycle: "Cyclisme",
      sport_both: "Les deux",
      level: "Niveau",
      level_beginner: "Débutant",
      level_intermediate: "Intermédiaire",
      level_advanced: "Avancé",
      level_competition: "Compétition ou Athlète",
      level_unknown: "Je ne sais pas — À évaluer",
      level_rehab: "Réadaptation (blessure / demande d'un professionnel de la santé)",
      goals: "Quels sont vos objectifs ?",
      email: "Courriel",
      phone: "Numéro de téléphone",
      coach: "Coach souhaité",
      coach_any: "Indifférent",
      date: "Date",
      time: "Créneau",
      notes: "Notes additionnelles (optionnel)",
      submit: "Payer & confirmer",
      submitting: "Création de la session...",
      select_package: "Sélectionnez une formule",
      change: "Modifier",
      need_help: "Besoin d'aide ?",
      need_help_body: "Contactez-nous, nous reviendrons vers vous rapidement.",
      required: "Requis",
    },
    payment: {
      verifying: "Vérification du paiement...",
      success_title: "Paiement confirmé.",
      success_body:
        "Merci pour votre confiance. Vous recevrez un email de confirmation avec les détails de votre séance.",
      pending_title: "Paiement en cours...",
      pending_body: "Nous vérifions le statut de votre transaction.",
      expired_title: "Session expirée.",
      expired_body: "Votre session de paiement a expiré. Veuillez recommencer.",
      back_home: "Retour à l'accueil",
      see_booking: "Voir ma réservation",
    },
    footer: {
      tagline: "Coaching natation & cyclisme sur mesure.",
      nav: "Navigation",
      contact: "Contact",
      legal: "Mentions légales",
      newsletter: "Restez dans le flow",
      newsletter_body: "Conseils, programmes et actualités. Pas de spam.",
      newsletter_placeholder: "Votre email",
      newsletter_submit: "S'inscrire",
      rights: "Tous droits réservés.",
    },
    common: {
      loading: "Chargement...",
      error: "Une erreur est survenue.",
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      kids: "Kids",
      about: "Our Story",
      coaches: "Coaches",
      pricing: "Pricing",
      booking: "Book",
      book_cta: "Book a session",
      account: "My account",
    },
    account: {
      title: "My account",
      login_tab: "Log in",
      register_tab: "Create account",
      email: "Email",
      password: "Password",
      password_confirm: "Confirm password",
      name: "Full name",
      phone: "Phone number",
      address: "Address (street)",
      city: "City",
      postal_code: "Postal code",
      province: "Province",
      login_submit: "Log in",
      register_submit: "Create my account",
      logout: "Log out",
      welcome: "Hello",
      profile_title: "My information",
      bookings_title: "My bookings",
      no_bookings: "No bookings yet.",
      save: "Save changes",
      saved: "Profile updated.",
      password_mismatch: "Passwords do not match.",
      booking_date: "Date",
      booking_package: "Package",
      booking_status: "Status",
      booking_payment: "Payment",
      book_cta: "Book a session",
      availability_title: "My availability",
      availability_help: "Check the time slots when you are usually available (weekdays and weekend). A manager will contact you to confirm.",
      manager_notice: "Thank you! A manager will contact you shortly to confirm your availability and schedule your first session around the existing bookings.",
    },
    days: {
      mon: "Monday", tue: "Tuesday", wed: "Wednesday", thu: "Thursday",
      fri: "Friday", sat: "Saturday", sun: "Sunday",
    },
    periods: { am: "Morning", pm: "Afternoon", eve: "Evening" },
    home: {
      overline: "Swimming · Cycling · Triathlon",
      title_l1: "Get",
      title_l2: "in the",
      title_accent: "Flow",
      subtitle:
        "Custom coaching for swimmers and cyclists. From your first stroke to the podium, we build your performance with method.",
      cta_primary: "Book a session",
      cta_secondary: "Our story",
      identity_overline: "The FLOW method",
      identity_title: "Sport as an art of movement.",
      identity_body:
        "Every athlete is unique. Our approach combines technique, physiology and joy to unlock your potential — at any level.",
      services_overline: "Our disciplines",
      services_title: "Two worlds, one standard.",
      service_swim_title: "Swimming",
      service_swim_body:
        "Stroke technique, open water, triathlon prep. Pool sessions and lake camps.",
      service_cycle_title: "Cycling",
      service_cycle_body:
        "Road, gravel, indoor. Personalized training plans, power analysis and race prep.",
      learn_more: "Learn more",
      stats: {
        athletes: "Athletes coached",
        years: "Years of experience",
        races: "Client podiums",
        rating: "Satisfaction",
      },
      testimonials_overline: "Trusted by",
      testimonials_title: "Results that speak.",
    },
    kids: {
      overline: "Kids' lessons",
      title: "Swimming, from the earliest years.",
      body:
        "Baby swim, kids, teens: we offer lessons tailored to every age — from first contact with water to advanced technique. A playful, safe and progressive approach, led by Société de sauvetage-certified coaches.",
      bullet1: "Parent & tot",
      bullet2: "Preschool",
      bullet3: "Levels 1 to 6",
      bullet4: "Junior lifeguards",
      cta: "Book for my child",
    },
    kidspage: {
      overline: "Kids' swimming lessons",
      title: "Swimming, from the earliest years.",
      lead:
        "Baby swim, kids, teens: we offer lessons tailored to every age — from first contact with water to advanced technique. A playful, safe and progressive approach, led by Société de sauvetage-certified coaches.",
      badge: "Official Swim for Life program — Société de sauvetage",
      kids_groups_title: "Kids & youth programs",
      m1_title: "Parent and child",
      m1_levels: "Levels 1 · 2 · 3",
      m1_age: "Up to 3 years",
      m1_desc: "With a parent in the water: water awakening, confidence and first reflexes, in full safety.",
      m2_title: "Preschool",
      m2_levels: "Levels 1 to 5",
      m2_age: "3 to 5 years",
      m2_desc: "Getting comfortable with water, floating, submersion and first movements — all through play.",
      m3_title: "Swimmer",
      m3_levels: "Levels 1 to 6",
      m3_age: "5 years and +",
      m3_desc: "Learning swim strokes, endurance and technique to gain ease and autonomy.",
      m4_title: "Swimmer — Junior lifeguard",
      m4_levels: "Levels 7 · 8 · 9",
      m4_age: "8 years and +",
      m4_desc: "Refinement, endurance and first lifesaving skills. Prepares for the rest of the journey.",
      bronze_label: "What's next?",
      bronze_title: "Bronze Star · Swimmer 10",
      bronze_desc: "To continue your training toward the lifeguard program, sign up for the Bronze Star (Swimmer 10).",
      adults_title: "Adults & fitness",
      a1_title: "Adult swimmer",
      a1_levels: "Levels 1 · 2 · 3",
      a1_age: "16 years and +",
      a1_desc: "Learn to swim or refine your technique at any age, at your own pace.",
      a2_title: "Fitness",
      a2_levels: "All levels",
      a2_age: "Any age",
      a2_desc: "For swimmers of all ages who want to improve their overall fitness.",
      survive_label: "Water safety",
      survive_title: "The Swim to Survive Standard",
      survive_lead: "The Swim to Survive standard assesses each child's aquatic skills and teaches them the basic skills needed to survive an unexpected fall into deep water.",
      s1_skill: "Roll entry",
      s1_goal: "Orient yourself at the water's surface after an unexpected fall.",
      s2_skill: "Tread water for 1 minute",
      s2_goal: "Stay at the surface and spot a safe place.",
      s3_skill: "Swim 50 metres",
      s3_goal: "Swim to a safe location.",
      why_title: "Why trust us with your children",
      why1_title: "Safety first",
      why1_desc: "Coaches certified by Société de sauvetage. Safety guides every session.",
      why2_title: "A playful approach",
      why2_desc: "Learning while having fun: tailored games and challenges so every child progresses with joy.",
      why3_title: "At home or in the pool",
      why3_desc: "Custom private lessons across greater Montréal, on your schedule and at your child's pace.",
      book_module: "Book this program",
      cta: "Book for my child",
      cta_secondary: "Ask a question",
    },
    services: {
      overline: "Services",
      title: "Custom swimming & cycling coaching.",
      subtitle:
        "For all ages and levels — from babies to triathletes. Coaches certified by Cyclisme Canada and Société de sauvetage.",
      swim_title: "Swimming",
      swim_body:
        "From first contact with water to triathlon or open water prep. Sessions tailored to every profile — babies, kids, teens, adults, competitors.",
      swim_bullet1: "Private lessons (all ages and levels)",
      swim_bullet2: "Stroke refinement",
      swim_bullet3: "Training plans (triathlon, open water, pool)",
      swim_bullet4: "Beginner to advanced coaching",
      swim_bullet5: "Test / exam prep (lifesaving, first responders, etc.)",
      cycle_title: "Cycling",
      cycle_body:
        "Personalized road, track and triathlon coaching. Structured plans, fine technical analysis and race or personal-goal prep.",
      cycle_bullet1: "Personalized coaching (road, track, triathlon)",
      cycle_bullet2: "Structured training plans",
      cycle_bullet3: "Technical analysis (position, cadence, efficiency)",
      cycle_bullet4: "Race prep (70.3, Gran Fondo, etc.)",
      cycle_bullet5: "Weekly personalized follow-up",
      cycle_bullet6: "Bike fitting",
    },
    about: {
      overline: "Our story",
      title: "Born from passion. Built for performance.",
      p1:
        "FLOW was born in 2025 in Montréal, founded by a lifeguard with a degree in social work and a kinesiology student. Outraged by the price of private lessons — to the point where practising sport had become a luxury — she set out to change that.",
      p2:
        "Her belief: private coaching should be accessible to everyone, without ever sacrificing quality or expertise. Here, we stay human, listening to every client who wants to improve and become a better version of themselves.",
      p3:
        "Certified by Société de sauvetage and Cyclisme Canada, we work with swimmers and cyclists of all levels through a personalized approach: understand your story, your constraints, your goals — then build a program that respects them all.",
      p4:
        "Over the last few years, the team has grown: certified and experienced coaches have joined FLOW to expand the community.",
      p5:
        "Today, more than 100 athletes have trusted us — from absolute beginners to seasoned triathletes. Every story is unique, and we write it with you.",
      values_title: "Our mission",
      v1_title: "Accessible to all",
      v1_body: "Make private coaching affordable and accessible to everyone.",
      v2_title: "Healthy progress",
      v2_body: "Help athletes progress and build a healthy relationship with performance.",
      v3_title: "A community",
      v3_body: "Build a community that trains with joy, discipline and balance.",
    },
    coaches: {
      overline: "The team",
      title: "Our team.",
      subtitle: "A personal approach, one standard: yours.",
    },
    pricing: {
      overline: "Pricing",
      title: "Pick your plan.",
      subtitle:
        "Custom swimming coaching and virtual cycling follow-up. Travel fees apply only outside Montréal.",
      per_session: "per session",
      total: "Total",
      book_now: "Book",
      popular: "Most popular",
      swim_section: "Kids & youth swimming",
      swim_section_sub: "Up to 15 years · 30-minute lessons",
      swim_adult_section: "Adult swimming",
      swim_adult_section_sub: "16 years and up · 1-hour lessons",
      cycle_section: "Cycling",
      cycle_section_sub: "Road bike only",
      tri_section: "Triathlon",
      travel_notice: "Travel fee of $15 to $30 only for sessions outside Montréal (depending on distance).",
    },
    booking: {
      overline: "Booking",
      title: "Book your session.",
      subtitle: "Fill the form — we confirm your slot within 24h.",
      summary_title: "Summary",
      program: "Selected program",
      step_package: "Package",
      step_about: "About you",
      step_profile: "Your sport profile",
      step_contact: "Contact info",
      step_date: "Date & time",
      full_name: "First & last name",
      gender: "Gender",
      gender_female: "Female",
      gender_male: "Male",
      gender_other: "Other / Prefer not to say",
      age: "Age",
      region: "Which region do you live in?",
      region_montreal: "Montréal",
      region_rive_sud: "Rive-Sud",
      region_rive_nord: "Rive-Nord",
      region_other: "Other",
      sport: "Which of our sports interests you?",
      sport_swim: "Swimming",
      sport_cycle: "Cycling",
      sport_both: "Both",
      level: "Level",
      level_beginner: "Beginner",
      level_intermediate: "Intermediate",
      level_advanced: "Advanced",
      level_competition: "Competition or Athlete",
      level_unknown: "I don't know — to be assessed",
      level_rehab: "Rehab (injury / health professional referral)",
      goals: "What are your goals?",
      email: "Email",
      phone: "Phone number",
      coach: "Preferred coach",
      coach_any: "Any",
      date: "Date",
      time: "Time",
      notes: "Additional notes (optional)",
      submit: "Pay & confirm",
      submitting: "Creating session...",
      select_package: "Select a package",
      change: "Change",
      need_help: "Need help?",
      need_help_body: "Contact us, we'll get back to you quickly.",
      required: "Required",
    },
    payment: {
      verifying: "Verifying payment...",
      success_title: "Payment confirmed.",
      success_body:
        "Thank you for your trust. You'll receive a confirmation email with your session details.",
      pending_title: "Payment processing...",
      pending_body: "We are checking your transaction status.",
      expired_title: "Session expired.",
      expired_body: "Your payment session expired. Please try again.",
      back_home: "Back to home",
      see_booking: "See my booking",
    },
    footer: {
      tagline: "Custom swimming & cycling coaching.",
      nav: "Navigation",
      contact: "Contact",
      legal: "Legal",
      newsletter: "Stay in the flow",
      newsletter_body: "Tips, programs and news. No spam.",
      newsletter_placeholder: "Your email",
      newsletter_submit: "Subscribe",
      rights: "All rights reserved.",
    },
    common: {
      loading: "Loading...",
      error: "Something went wrong.",
    },
  },
};
